import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { isNativeMobile } from "global/utils/platformDetector";
import { useContext } from "react";
import { useHistory } from "react-router";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import TildeOk from "../../../assets/images/generico/TildeOk";
import { ContainerAtencionSinTunroSelect } from "./localStyle";

const AtencionSinTurnoSelect = () => {
  // -------------------------  context ----------------------------
  const { authState } = useContext(GlobalContext);
  const { pasoDispatch } = useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);

  // -------------------------  context ----------------------------

  // -------------------------  constants ----------------------------
  const FORCE_NATIVE_VIEW = true; // ACTIVADO PARA PRUEBAS - mostrar botón nativo
  const pacienteNombre = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.nombre
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre ?? "";
  const history = useHistory();
  const isNativePlatform = isNativeMobile() || FORCE_NATIVE_VIEW;

  // -------------------------  constants ----------------------------

  // -------------------------  functions ----------------------------

  const handleAtencionDia = () => {
    setPaso("UbicacionSinTurno")(pasoDispatch);
  };

  const handleInformacionGeneral = () => {
    history.push("/atencionSinTurno");
  };
  // -------------------------  functions ----------------------------

  return (
    <LayoutPasos
      title={"necesito turno"}
      subtitle={"Para: " + camelize(pacienteNombre)}
      handleClick={() => {
        setPaso("NecesitoTurno")(pasoDispatch);
      }}
    >
      <ContainerAtencionSinTunroSelect
        initial={{ opacity: 0, y: +100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <span className="title">
          Seleccione según necesite un turno para el día de hoy o si necesita
          información sobre atención sin turno{" "}
        </span>
        {isNativePlatform && (
          <BtnLink
            Icon={
              <TildeOk
                color={"var(--color-primary)"}
                width={"20"}
                height={"20"}
              />
            }
            title={"ATENCIÓN EN EL DÍA"}
            type="NORMAL"
            onclick={handleAtencionDia}
          />
        )}
        <BtnLink
          Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
          title={"INFORMACIÓN GENERAL"}
          type="NORMAL"
          onclick={handleInformacionGeneral}
          spacingWord={true}
        />
      </ContainerAtencionSinTunroSelect>
    </LayoutPasos>
  );
};

export default AtencionSinTurnoSelect;
